import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=5ddaa291&scoped=true"
import script from "./SystemError.vue?vue&type=script&lang=js"
export * from "./SystemError.vue?vue&type=script&lang=js"
import style0 from "./SystemError.vue?vue&type=style&index=0&id=5ddaa291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddaa291",
  null
  
)

export default component.exports